export default "__VITE_ASSET__OZ9IuBWpuPIUB8Ik_j9OyA__"